import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TruncatePipe } from '@netfoundry-ui/ui/pipes';
import { DateRangeCalendarComponent } from '@netfoundry-ui/ui/date-range-calendar';
import { SharedApiv2Module } from '@netfoundry-ui/shared/apiv2';
import { DialLogsTimelineTabComponent } from './dial-logs-timeline-tab.component';
import { DialLogsTimelineModalComponent } from './dial-logs-timeline-modal.component';
import { DialLogsTimelineDrawerComponent } from './dial-logs-timeline-drawer.component';
import { DialLogsFailureDetailComponent } from './dial-logs-failure-detail.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        MatDialogModule,
        MatTooltipModule,
        SharedApiv2Module,
        TruncatePipe,
        DateRangeCalendarComponent,
    ],
    declarations: [
        DialLogsTimelineTabComponent,
        DialLogsTimelineModalComponent,
        DialLogsTimelineDrawerComponent,
        DialLogsFailureDetailComponent,
    ],
    exports: [DialLogsTimelineTabComponent, DialLogsTimelineModalComponent, DialLogsTimelineDrawerComponent],
})
export class FeatureDialLogsTimelineModule {}
